import { useController } from '@aha-app/mvc';
import React, { useEffect } from 'react';
import customElementBoolAttr from '../../../utils/customElementBoolAttr';
import VotingSessionController from './controllers/VotingSessionController';
import styles from './VotingSession.module.css';

export const VotingSetupSelectedObjectsControls = ({
  onlySelected,
  numObjects,
  selectedEnoughObjects,
  selectedTooManyObjects,
}: {
  onlySelected: boolean;
  numObjects: number;
  selectedEnoughObjects: boolean;
  selectedTooManyObjects: boolean;
}) => {
  const controller = useController(VotingSessionController);
  const onlySelectedRef = React.useRef<HTMLAhaSwitchElement>(null);

  useEffect(() => {
    const toggle = onlySelectedRef.current;

    if (toggle) {
      const handler = () => {
        controller.actionSetOnlySelected(!!toggle.active);
      };

      toggle.addEventListener('aha-switch:change', handler);

      return () => {
        toggle.removeEventListener('aha-switch:change', handler);
      };
    }
  }, [controller]);

  return (
    <>
      <div className={styles.optionToggleInput}>
        <p className='m-0 color-secondary'>Only selected objects</p>
        <aha-switch
          ref={onlySelectedRef}
          active={customElementBoolAttr(onlySelected)}
          disabled={customElementBoolAttr(
            numObjects > VotingSessionController.OBJECT_LIMIT
          )}
        />
        {numObjects > VotingSessionController.OBJECT_LIMIT && (
          <aha-tooltip>
            Maximum of 300 objects allowed in a voting session. Select desired
            objects to continue.
          </aha-tooltip>
        )}
      </div>
      {!selectedEnoughObjects && (
        <aha-alert type='danger'>Select at least two objects.</aha-alert>
      )}
      {selectedTooManyObjects && (
        <aha-alert type='danger'>
          Select no more than {VotingSessionController.OBJECT_LIMIT} objects.
        </aha-alert>
      )}
    </>
  );
};
